import { getPileRingDiameter } from "../editor-data";
import { createSubmissionGate } from "../submission-gate";
import { showEditorSaved, focusEditorField } from "../editor-feedback";
import useMediaQuery from "Utils/hooks/use-media-query";
import { PI } from 'Constants/general';
import React, {useEffect, useRef, useState} from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'Redux/hooks';
import { createPile, fetchDefaultsPiles, updatePile } from 'Redux/middlwares/pile';
import { postMedia } from 'Services/media';
import PileMobileContent from './mobile/content';
import html2canvas from 'html2canvas';
import PilesSideBar from "./web/SideBar";
import PileShape from "./shape/shape";


import SideBar from "../blocks/left-sidebar";
import SketchBody from "../blocks/sketch-body";
import LastAddedSidebar from "../blocks/right-sidebar";
import PilesCard from "../blocks/right-sidebar/piles-cards/PilesCards";
import {
  getEditableTool,
  getPilePresentation,
  hasRequiredPileDiameters,
  isUsablePileCatalogShape,
} from "../editor-data";

import { useTranslation } from "react-i18next";
import {
  CAGE_LEN_MIN,
  CAGE_LEN_MAX,
  pileErrorTypes,
  polygonSteelType,
  DEFAULT_SIDE_DIAMETER,
  DEFAULT_EXTERNAL_AMOUNT,
  DEFAULT_INTERNAL_AMOUNT,
  DEFAULT_MIDDLE_AMOUNT,
} from "Constants/pile-constants";

function Pile ({
  setLoader,
  handleClose,
  onSavingChange,
  edit,
  selectedTool,
  setSelectedTool,
  setIsStopped,
  tab,
  setTab,
  checkRowNums,
  editOrderId,
  editMode,
  deleteTool,
  copyOrderItem,
  setEditTool,
  order,
  editToolId,
}: any) {
  const isMobile = useMediaQuery("(max-width: 991.98px)");
  const isBrowser = !isMobile;
  const dispatch = useAppDispatch();
  const submission = useRef(createSubmissionGate());
  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const stageRef = useRef(null);
  const standardShapes = useAppSelector(state => state.pile.defaultPiles);
  const steelDiameters = useAppSelector(state => state.steelType.steelDiameters);
  const currentOrderPiles = useAppSelector((state) => state.pile.currentOrderPiles);
  const nextOrderPilesPage = useAppSelector((state) => state.pile.orderPilePage);
  const [pileNumber, setPileNumber] = useState("C");
  const [base, setBase] = useState(true);
  const [ring, setRing] = useState(false);
  const [gama, setGama] = useState(false);
  const [ear, setEar] = useState(false);
  const [sideSpilt, setSideSplit] = useState(2);
  const [selectedShape, setSelectedShape] = useState(0);
  const [initiateImage, setInitiateImage] = useState(false);

  const [errorsText, setErrorsText] = useState<any[]>([]);
  const { t } = useTranslation(["common", "tool", "measurements"]);

  const finishButtonRef = useRef(null);
  const addButtonRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  const [shapeObj, setShape] = useState({
    ...standardShapes[selectedShape]
  });
  const [orderItem, setOrderItem] = useState({
    quantity: 0,
    production_notes: "",
    position_notes: "",
  });

  const [labelingPoints, setLabelingPoints] = useState({
    l1_start: {x:0, y:0},
    l2_start: {x:0, y:0},
    l3_start: {x:0, y:0},
    l3_end: {x:0, y:0},

    gap1_start: {x:0, y:0},
    gap1_end: {x:0, y:0},

    gap2_start: {x:0, y:0},
    gap2_end: {x:0, y:0},

    ear_start: {x:0, y:0},
    ear_end: {x:0, y:0},
  });


  const [pilesData, setPilesData] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [progressBarSelectedShape, setProgressBarSelectedShape] = useState(-1);
  const [isShapeError, setIsShapeError] = useState(false);

  // Unsaved changes protection
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    onSavingChange?.(isSaving);
    return () => onSavingChange?.(false);
  }, [isSaving, onSavingChange]);
  const [showUnsavedWarning, setShowUnsavedWarning] = useState(false);
  const ignoreUnsavedChangesRef = useRef(true);
  const isDirtyRef = useRef(false);
  const requestCloseRef = useRef<() => void>(() => {});
  const showUnsavedWarningRef = useRef(false);
  const [showSaveErrorModal, setShowSaveErrorModal] = useState(false);
  const [saveErrorMessage, setSaveErrorMessage] = useState("");

  const markAsDirty = () => {
    if (ignoreUnsavedChangesRef.current || isSaving) return;

    isDirtyRef.current = true;
    setHasUnsavedChanges(true);
  };

  const handleSaveFailure = (message: string) => {
  submission.current.end();
  setIsSaving(false);
  setInitiateImage(false);
  setIsStopped(true);

  ignoreUnsavedChangesRef.current = false;
  isDirtyRef.current = true;

  setHasUnsavedChanges(true);
  setSaveErrorMessage(message);
  setShowSaveErrorModal(true);
};


  // These setters are passed to the editable child components.
  // Every real user change must go through one of them.
  const setShapeFromUser = (value: any) => {
    markAsDirty();
    setShape(value);
  };

  const setOrderItemFromUser = (value: any) => {
    markAsDirty();
    setOrderItem(value);
  };

  const setBaseFromUser = (value: any) => {
    markAsDirty();
    setBase(value);
  };

  const setRingFromUser = (value: any) => {
    markAsDirty();
    setRing(value);
  };

  const setGamaFromUser = (value: any) => {
    markAsDirty();
    setGama(value);
  };

  const setEarFromUser = (value: any) => {
    markAsDirty();
    setEar(value);
  };

  const setSideSplitFromUser = (value: any) => {
    markAsDirty();
    setSideSplit(value);
  };

  const setSelectedShapeFromUser = (value: any) => {
    markAsDirty();
    setSelectedShape(value);
  };

  const setPileNumberFromUser = (value: any) => {
    markAsDirty();
    setPileNumber(value);
  };

  const continueEditing = () => setShowUnsavedWarning(false);

  const discardChangesAndClose = () => {
    setShowUnsavedWarning(false);
    ignoreUnsavedChangesRef.current = true;
    isDirtyRef.current = false;
    setHasUnsavedChanges(false);
    handleClose();
  };

  const requestClose = () => {
    if (isSaving) return;

    if (isDirtyRef.current || hasUnsavedChanges) {
      isDirtyRef.current = true;
      setHasUnsavedChanges(true);
      setShowUnsavedWarning(true);
      return;
    }

    handleClose();
  };

  requestCloseRef.current = requestClose;
  showUnsavedWarningRef.current = showUnsavedWarning;

  useEffect(() => {
    const interceptOuterModalClose = (event: MouseEvent) => {
      if (showUnsavedWarningRef.current) return;

      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const isModalBackdrop = target.classList.contains("modal");
      const isUnsavedWarningModal = Boolean(
        target.querySelector(".unsaved-warning-modal")
      );

      if (!isModalBackdrop || isUnsavedWarningModal) return;

      event.preventDefault();
      event.stopPropagation();
      requestCloseRef.current();
    };

    const interceptEscapeClose = (event: KeyboardEvent) => {
      if (event.key !== "Escape" || showUnsavedWarningRef.current) return;

      event.preventDefault();
      event.stopPropagation();
      requestCloseRef.current();
    };

    document.addEventListener("click", interceptOuterModalClose, true);
    document.addEventListener("keydown", interceptEscapeClose, true);

    return () => {
      document.removeEventListener("click", interceptOuterModalClose, true);
      document.removeEventListener("keydown", interceptEscapeClose, true);
    };
  }, []);

  // Initialization and switching between new/edit modes must not be treated
  // as user changes. Enable dirty tracking only after the form is ready.
  useEffect(() => {
    if (isLoading) {
      ignoreUnsavedChangesRef.current = true;
      return;
    }

    ignoreUnsavedChangesRef.current = true;
    isDirtyRef.current = false;
    setHasUnsavedChanges(false);
    setShowUnsavedWarning(false);

    const timeoutId = window.setTimeout(() => {
      ignoreUnsavedChangesRef.current = false;
    }, 300);

    return () => window.clearTimeout(timeoutId);
  }, [isLoading, edit, selectedTool?.id]);

  const addError = (newError: any) => {
    if (!errorsText.some((error) => error.errorType === newError.errorType)) {
      setErrorsText((prevErrors) => [...prevErrors, newError]);
    }
  };

  const removeError = (errorType: number) => {
    setErrorsText((prevErrors) =>
      prevErrors.filter((error) => error.errorType !== errorType)
    );
  };

  const setDefaultSplitValues = (split, checkError = false)=>{
    const availableDiameters = steelDiameters[shapeObj.length_steel_type] || [];
    const defaultSideDiameter =
      availableDiameters.find(
        (item: any) => item.steel_diameter === DEFAULT_SIDE_DIAMETER
      ) || availableDiameters.find((item: any) => item?.id);
    if(split === 2){
      const currentShape = {
        ...shapeObj,
        internal_diameter: shapeObj.internal_diameter?.id
          ? shapeObj.internal_diameter
          : defaultSideDiameter,
        external_diameter: shapeObj.external_diameter?.id
          ? shapeObj.external_diameter
          : defaultSideDiameter,
        external_amount: shapeObj.external_amount
          ? shapeObj.external_amount
          : DEFAULT_EXTERNAL_AMOUNT,
        internal_amount: shapeObj.internal_amount
          ? shapeObj.internal_amount
          : DEFAULT_INTERNAL_AMOUNT
      };  
      setShape(currentShape);
      if(checkError){
        checkSideAmountErrors(2, currentShape);
      }
    }
    if (split === 3){
      const currentShape = {
        ...shapeObj,
        internal_diameter: shapeObj.internal_diameter?.id
        ? shapeObj.internal_diameter
        : defaultSideDiameter,
        external_diameter: shapeObj.external_diameter?.id
          ? shapeObj.external_diameter
          : defaultSideDiameter,
        external_amount: shapeObj.external_amount
          ? shapeObj.external_amount
          : DEFAULT_EXTERNAL_AMOUNT,
        internal_amount: shapeObj.internal_amount
          ? shapeObj.internal_amount
          : DEFAULT_INTERNAL_AMOUNT,
        middle_diameter: shapeObj.middle_diameter?.id
        ? shapeObj.middle_diameter
        : defaultSideDiameter,
        middle_amount: shapeObj.middle_amount
          ? shapeObj.middle_amount
          : DEFAULT_MIDDLE_AMOUNT,    
      };
      setShape(currentShape);
      if(checkError){
        checkSideAmountErrors(3, currentShape);
      }
    }
  }

  const checkSideAmountErrors = (split, currentShape )=>{
    let isError = false;
    if (
      parseInt(currentShape.external_amount) < 2 ||
      currentShape.external_amount === null
    ) {
      addError({
        errorType: pileErrorTypes.MIN_EXTERNAL_AMOUNT,
        message: t("error_side_min", { ns: "tool" }),
      });
      isError = true;
    } else {
      removeError(pileErrorTypes.MIN_EXTERNAL_AMOUNT);
    }

    if (
      parseInt(currentShape.internal_amount) < 2 ||
      currentShape.internal_amount === null
    ) {
      addError({
        errorType: pileErrorTypes.MIN_INTERNAL_AMOUNT,
        message: t("error_side_min", { ns: "tool" }),
      });
      isError = true;
    } else {
      removeError(pileErrorTypes.MIN_INTERNAL_AMOUNT);
    }
    
    if (split === 3){
      if (
        parseInt(currentShape.middle_amount) < 2 ||
        currentShape.middle_amount === null) 
      {
        addError({
          errorType: pileErrorTypes.MIN_MIDDLE_AMOUNT,
          message: t("error_side_min", { ns: "tool" }),
        });
        isError = true;
      } else {
        removeError(pileErrorTypes.MIN_MIDDLE_AMOUNT);
      }  
    } else {
      removeError(pileErrorTypes.MIN_MIDDLE_AMOUNT);
    }
    return isError;
  }
  

  useEffect(()=>{
    if(!isLoading){
      setDefaultSplitValues(3);
    }
  }, [isLoading])

  useEffect(()=>{
    if (currentOrderPiles) {
      setPilesData(currentOrderPiles);
      if (nextOrderPilesPage !== false) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    }
  }, [currentOrderPiles])

  const initializePilePresentation = (pileShape: any) => {
    const presentation = getPilePresentation(pileShape);

    setBase(presentation.base);
    setSideSplit(presentation.sideSplit);
    setRing(pileShape?.ring_diameter != null);
    setGama(pileShape?.gama_diameter != null);
    setEar(pileShape?.ear_length != null);
  };

  useEffect(() => {
    const editableTool = getEditableTool(edit, selectedTool);
    if (editableTool) {
      const ringDiam = getRingDiamObj(editableTool.ring_diameter);
      const parsedShape = {
        ...editableTool,
        ring_diameter: ringDiam,
        cover: editableTool.hole_diameter - editableTool.cage_diameter
      };
      setShape(parsedShape);
      initializePilePresentation(parsedShape);
      setOrderItem({
        quantity: selectedTool.quantity,
        production_notes: selectedTool.production_notes,
        position_notes: selectedTool.position_notes,
      });
      setIsLoading(false);
    } else if (!edit && standardShapes.length > 0) {
      const selectedDefault = standardShapes[selectedShape];
      if (isUsablePileCatalogShape(selectedDefault)) {
        setShape({ ...selectedDefault });
        initializePilePresentation(selectedDefault);
        setIsShapeError(false);
      } else {
        setIsShapeError(true);
        addError({
          errorType: "INVALID_PILE_DATA",
          message: t("invalid pile data", { ns: "tool" }),
        });
      }
      setIsLoading(false);
    }
  }, [
    standardShapes,
    selectedShape,
    edit,
    selectedTool,
    selectedTool?.tool,
  ]);

  useEffect(() => {
    if (shapeObj.cage_steel_type && !(steelDiameters[shapeObj.cage_steel_type])) {
      dispatch(fetchSteelDiameters(shapeObj.cage_steel_type));
    }
    if (shapeObj.length_steel_type && !(steelDiameters[shapeObj.length_steel_type])) {
      dispatch(fetchSteelDiameters(shapeObj.length_steel_type));
    }
  }, [shapeObj, steelDiameters, dispatch]);

  useEffect(() => {
    const initalFetch = async () => {
      setLoader(true);
      standardShapes.length === 0 && await dispatch(fetchDefaultsPiles());
      setLoader(false);
    }
    initalFetch();
    setSelectedShape(0);
  }, [dispatch, setLoader, standardShapes.length]);

  async function savePile() {
    if (submission.current.pending || isSaving || isShapeError) {
      return;
    }

    if (
      parseInt(orderItem.quantity) === 0 ||
      Number.isNaN(parseInt(orderItem.quantity))
    ) {
      focusEditorField("quantity");
      addError({
        errorType: pileErrorTypes.QUANTITY,
        message: t("error_cage_amount", { ns: "tool" }),
      });
      return;
    }

    if (!base && checkSideAmountErrors(sideSpilt, shapeObj)) {
      return;
    }

    if (!hasRequiredPileDiameters(shapeObj, base, sideSpilt)) {
      addError({
        errorType: "INVALID_PILE_DIAMETERS",
        message: t("invalid pile data", { ns: "tool" }),
      });
      return;
    }

    removeError("INVALID_PILE_DIAMETERS");

    if (!stageRef.current) {
      handleSaveFailure(
        t("preview pile unavailable", { ns: "tool" })
      );
      return;
    }

    if (!submission.current.begin()) return;
    setIsSaving(true);
    setInitiateImage(true);
    setIsStopped(false);

    try {
      await new Promise((resolve) => window.setTimeout(resolve, 100));

      const canvas = await getHtmlToCanvas(stageRef.current);
      const previewImg = (canvas as any).toDataURL({
        mimeType: "image/png",
        quality: 1,
        pixelRatio: 3,
      });

      const mediaResponse = await postMedia(
        previewImg,
        `pile_preview_${Date.now()}.png`,
        `piles ${Date.now()}`
      );
      if (!mediaResponse?.data) {
        throw new Error("Media save failed");
      }

      let newPileShape = {
        ...shapeObj,
        tool_number: pileNumber,
        preview_image: mediaResponse.data.id,
        base_diameter: base ? shapeObj.base_diameter.id : null,
        spiral_wire_diameter: shapeObj.spiral_wire_diameter.id,
        external_diameter:
          shapeObj.external_diameter && shapeObj.external_diameter.id
            ? shapeObj.external_diameter.id
            : null,
        middle_diameter:
          shapeObj.middle_diameter && shapeObj.middle_diameter.id
            ? shapeObj.middle_diameter.id
            : null,
        internal_diameter:
          shapeObj.internal_diameter && shapeObj.internal_diameter.id
            ? shapeObj.internal_diameter.id
            : null,
        ring_diameter:
          shapeObj.ring_diameter && shapeObj.ring_diameter.id
            ? shapeObj.ring_diameter.id
            : null,
      };

      let deleteKeys = ["created", "last_modified", "cover"];
      if (!ring) deleteKeys = [...deleteKeys, "ring_diameter", "ring_quantity"];
      if (!gama) deleteKeys = [...deleteKeys, "gama_diameter", "gama_quantity"];
      if (!ear) deleteKeys = [...deleteKeys, "ear_type", "ear_length"];
      if (!base) deleteKeys = [...deleteKeys, "base_diameter", "base_amount"];
      if (sideSpilt === 2) {
        deleteKeys = [...deleteKeys, "middle_diameter", "middle_amount"];
      }
      if (base) {
        deleteKeys = [
          ...deleteKeys,
          "external_diameter",
          "external_amount",
          "middle_diameter",
          "middle_amount",
          "internal_diameter",
          "internal_amount",
        ];
      }

      let saveResult: any;

if (edit) {
  deleteKeys.forEach(
    (key: string) => delete newPileShape[key]
  );

  saveResult = await dispatch(
    updatePile(
      selectedTool.id,
      newPileShape,
      orderItem
    )
  );
} else {
  newPileShape = {
    ...newPileShape,
    type: 1,
    reference_tool: shapeObj.id,
  };

  deleteKeys.push("id");

  deleteKeys.forEach(
    (key: string) => delete newPileShape[key]
  );

  saveResult = await dispatch(
    createPile(
      newPileShape,
      orderItem,
      () => {},
      0,
      editOrderId
    )
  );
}

if (!saveResult?.success) {
  throw new Error(
    saveResult?.message || t("save pile failed", { ns: "tool" })
  );
}

      // The reset after a successful save is programmatic and must stay clean.
      ignoreUnsavedChangesRef.current = true;
      isDirtyRef.current = false;
      setHasUnsavedChanges(false);
      setShowUnsavedWarning(false);

      setDefaultShape();
      setInitiateImage(false);
      submission.current.end();
      setIsSaving(false);
      setTimeout(() => setIsStopped(true), 100);

      showEditorSaved("pile", saveResult.data?.id, edit, t, rightToLeft);
      if (isMobile || editToolId >= 0) {
        setTimeout(() => {
          isDirtyRef.current = false;
          setHasUnsavedChanges(false);
          handleClose();
        }, 350);
      } else {
        // Re-enable tracking only after the clean form has rendered.
        setTimeout(() => {
          ignoreUnsavedChangesRef.current = false;
        }, 350);
      }
    } catch (error) {
  console.error("Failed to save pile:", error);

  handleSaveFailure(
    t("save retry message", { ns: "tool" })
  );
}
  }


  const getLengthDiameter = (steelDiameterID: number) => {
    return steelDiameters[shapeObj.length_steel_type]?.find((item: any) => item.id === steelDiameterID);
  }

  const getSpiralDiameter = (steelDiameterID: number) => {
    return steelDiameters[shapeObj.cage_steel_type]?.find((item: any) => item.id === steelDiameterID);
  }

  const getPolygonDiameter = (steelDiameterID: number) => {
    return steelDiameters[polygonSteelType]?.find((item: any) => item.id === steelDiameterID);
  }

  const getRingDiamObj = (value: any) => getPileRingDiameter(value, steelDiameters[polygonSteelType]);

  useEffect(
    () => {
      const calculateWeight = () => {

        //gamma pipes are not effecting the unit weights right now
        let lengthsWeight = 0;
        const total_length = (shapeObj.l1_length + shapeObj.l2_length + shapeObj.l3_length) / 100;
        let earWeight = 0;
        if (base) {
          lengthsWeight = total_length * (shapeObj.base_amount || 0) * shapeObj.base_diameter.weight;
          earWeight = ((shapeObj.ear_length || 0) / 100) * (shapeObj.base_amount || 0) * shapeObj.base_diameter.weight;
        } else {
          lengthsWeight += total_length * (shapeObj.external_amount || 0) * (shapeObj.external_diameter.weight || 0);
          lengthsWeight += total_length * (shapeObj.internal_amount || 0) * (shapeObj.internal_diameter.weight || 0);

          earWeight += ((shapeObj.ear_length || 0) / 100) * (shapeObj.external_amount || 0) * (shapeObj.external_diameter.weight || 0);
          earWeight += ((shapeObj.ear_length || 0) / 100) * (shapeObj.internal_amount || 0) * (shapeObj.internal_diameter.weight || 0);

          if (sideSpilt === 3){
            lengthsWeight += total_length * (shapeObj.middle_amount || 0) * (shapeObj.middle_diameter.weight || 0);
            earWeight += ((shapeObj.ear_length || 0) / 100) * (shapeObj.middle_amount || 0) * (shapeObj.middle_diameter.weight || 0);
          }

          //external/internal/middle diameter weights should always be calculated according to the polygon steel types
        }

        const one_hoop_length = shapeObj.cage_diameter * PI;
        const number_of_hoops_l2 = shapeObj.l2_length / shapeObj.l2_gap;
        const number_of_hoops_l3 = shapeObj.l3_length / shapeObj.l3_gap;
        const total_number_of_hoops_length = (number_of_hoops_l2 + number_of_hoops_l3) * one_hoop_length;
        const spiralWeight = (total_number_of_hoops_length / 100) * shapeObj.spiral_wire_diameter.weight;

        const ringsWeight = (shapeObj.ring_quantity || 0) * (one_hoop_length/100) * (shapeObj?.ring_diameter?.weight || 0);

        let unitWeight = lengthsWeight + spiralWeight + earWeight + ringsWeight;

        if (!ear) {
          unitWeight = unitWeight - earWeight;
        }
        if (!ring) {
          unitWeight = unitWeight - ringsWeight;
        }
        setShape((prev: any) => ({...prev, unit_weight: unitWeight.toFixed(2)}));
      }

      if (base && shapeObj.base_diameter && shapeObj.spiral_wire_diameter) {
        calculateWeight();
      } else if (
        shapeObj.external_diameter
        && shapeObj.internal_diameter
        && shapeObj.middle_diameter
      ) {
        calculateWeight();
      }
    },
    [
      base,
      ring,
      ear,
      sideSpilt,
      steelDiameters,
      shapeObj.base_amount,
      shapeObj.base_diameter,
      shapeObj.cage_diameter,
      shapeObj.ear_length,
      shapeObj.external_amount,
      shapeObj.external_diameter,
      shapeObj.internal_amount,
      shapeObj.internal_diameter,
      shapeObj.l1_length,
      shapeObj.l2_gap,
      shapeObj.l2_length,
      shapeObj.l3_gap,
      shapeObj.l3_length,
      shapeObj.middle_amount,
      shapeObj.middle_diameter,
      shapeObj.ring_quantity,
      shapeObj.ring_diameter,
      shapeObj.spiral_wire_diameter
    ]
  );

  const getHtmlToCanvas = (ref: any) => {
    return new Promise((resolve, reject) => {
      html2canvas(ref, { allowTaint: true, useCORS: true, logging: true })
        .then((canvas) => {
          resolve(canvas);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  };


  const setDefaultShape = () => {
    setEditTool(false);
    setProgressBarSelectedShape(-1);
    setSelectedTool({id: 0})
    setErrorsText([]);
    const selectedDefault =
      (isUsablePileCatalogShape(standardShapes[selectedShape])
        ? standardShapes[selectedShape]
        : standardShapes.find(isUsablePileCatalogShape)) || {};
    setShape({
      ...selectedDefault,
      internal_amount: DEFAULT_INTERNAL_AMOUNT,
      external_amount: DEFAULT_EXTERNAL_AMOUNT,
      middle_amount: DEFAULT_MIDDLE_AMOUNT,
    });
    setOrderItem({
      quantity: 0,
      production_notes: "",
      position_notes: "",
      row_number: 0,
    });
    setBase(true);
    setSideSplit(1);
    setRing(false);
    setGama(false);
    setEar(false);
    setInitiateImage(false);
  }

  const checkCageLength = (l1, l2, l3, cage_diameter)=>{
    const total = parseInt(l1) + parseInt(l2) + parseInt(l3);
    if (total < CAGE_LEN_MIN){
      addError({
        errorType: pileErrorTypes.MIN_TOTAL_LEN,
        message: t("error_min_total_len", { ns: "tool" }),
      })
      removeError(pileErrorTypes.MAX_TOTAL_LEN)
    }
    else if ( total > CAGE_LEN_MAX ){
      addError({
        errorType: pileErrorTypes.MAX_TOTAL_LEN,
        message: t("error_max_total_len", { ns: "tool" }),
      })
      removeError(pileErrorTypes.MIN_TOTAL_LEN)
    }
    else{
      removeError(pileErrorTypes.MIN_TOTAL_LEN)
      removeError(pileErrorTypes.MAX_TOTAL_LEN)
    }
  }

  return (
    <>
      {isBrowser && (
        <>
          <SideBar tab={tab} setTab={setTab} edit={edit}>
            <PilesSideBar
              shapeObj={shapeObj}
              setShape={setShapeFromUser}
              base={base}
              setBase={setBaseFromUser}
              ring={ring}
              setRing={setRingFromUser}
              gama={gama}
              setGama={setGamaFromUser}
              ear={ear}
              setEar={setEarFromUser}
              sideSpilt={sideSpilt}
              setSideSplit={setSideSplitFromUser}
              selectedShape={selectedShape}
              setSelectedShape={setSelectedShapeFromUser}
              standardShapes={standardShapes}
              getDiameter={getLengthDiameter}
              edit={edit}
              orderItem={orderItem}
              setOrderItem={setOrderItemFromUser}
              isSaving={isSaving}
              savePile={savePile}
              errorsText={errorsText}
              setErrorsText={setErrorsText}
              addError={addError}
              removeError={removeError}
              isShapeError={isShapeError}
              setIsShapeError={setIsShapeError}
              checkCageLength={checkCageLength}
              finishButtonRef={finishButtonRef}
              addButtonRef={addButtonRef}
              setInitiateImage={setInitiateImage}
              checkSideAmountErrors={checkSideAmountErrors}
              setDefaultSplitValues={setDefaultSplitValues}
              getPolygonDiameter={getPolygonDiameter}
            />
          </SideBar>
          {/* <Content
            ear={ear}
            base={base}
            sideSpilt={sideSpilt}
            shapeObj={shapeObj}
            setShape={setShapeFromUser}
            labelingPoints={labelingPoints}
            setLabelingPoints={setLabelingPoints}
            isSaving={isSaving}
              savePile={savePile}
            orderItem={orderItem}
            setOrderItem={setOrderItemFromUser}
            getDiameter={getSpiralDiameter}
            stageRef={stageRef}
            pileNumber={pileNumber}
            setPileNumber={setPileNumberFromUser}
          /> */}
          <SketchBody>
            <PileShape
              ear={ear}
              sideSpilt={sideSpilt}
              shapeObj={shapeObj}
              setShape={setShapeFromUser}
              labelingPoints={labelingPoints}
              setLabelingPoints={setLabelingPoints}
              base={base}
              stageRef={stageRef}
              errorsText={errorsText}
              setErrorsText={setErrorsText}
              addError={addError}
              removeError={removeError}
              isShapeError={isShapeError}
              setIsShapeError={setIsShapeError}
              checkCageLength={checkCageLength}
              isLoading={isLoading}
              isPile={true}
              initiateImage={initiateImage}
            />
          </SketchBody>
          <LastAddedSidebar
            dataLength={pilesData.length}
            hasMore={hasMore}
            setHasMore={setHasMore}
            toolData={pilesData}
            setToolData={setPilesData}
            checkRowNums={checkRowNums}
            editOrderId={editOrderId}
            editMode={editMode}
            saveTool={savePile}
            shapeObj={shapeObj}
            edit={edit}
            finishButtonRef={finishButtonRef}
            addButtonRef={addButtonRef}
            //isShapesError={isShapesError}
            setDefaultShape={setDefaultShape}
            handleClose={requestClose}
            editToolId={editToolId}
          >
            <div
              className="card__list_piles hoveredItems"
              style={editToolId >= 0 ? { marginTop: "40px" } : {}}
            >
              {pilesData.map((item, index) => (
                <PilesCard
                  key={item.id}
                  id={item.id}
                  item={item.tool}
                  orderItem={item}
                  index={index}
                  deleteTool={deleteTool}
                  copyOrderItem={copyOrderItem}
                  setEditTool={setEditTool}
                  setSelectedTool={setSelectedTool}
                  setSelectedShape={setProgressBarSelectedShape}
                  selectedShape={progressBarSelectedShape}
                  setErrorsText={setErrorsText}
                  setInProgress={setInProgress}
                  inProgress={inProgress}
                  editToolId={editToolId}
                  edit={edit}
                />
              ))}
            </div>
          </LastAddedSidebar>
        </>
      )}
      {isMobile && (
        <PileMobileContent
          edit={edit}
          shapeObj={shapeObj}
          setShape={setShapeFromUser}
          base={base}
          setBase={setBaseFromUser}
          ring={ring}
          setRing={setRingFromUser}
          gama={gama}
          setGama={setGamaFromUser}
          ear={ear}
          setEar={setEarFromUser}
          labelingPoints={labelingPoints}
          setLabelingPoints={setLabelingPoints}
          orderItem={orderItem}
          setOrderItem={setOrderItemFromUser}
          getLengthDiameter={getLengthDiameter}
          getSpiralDiameter={getSpiralDiameter}
          selectedShape={selectedShape}
          setSelectedShape={setSelectedShapeFromUser}
          standardShapes={standardShapes}
          pileNumber={pileNumber}
          setPileNumber={setPileNumberFromUser}
          sideSpilt={sideSpilt}
          setSideSplit={setSideSplitFromUser}
          setDefaultSplitValues={setDefaultSplitValues}
          checkSideAmountErrors={checkSideAmountErrors}
          isShapeError={isShapeError}
          setIsShapeError={setIsShapeError}
          stageRef={stageRef}
          isLoading={isLoading}
          errorsText={errorsText}
          setErrorsText={setErrorsText}
          addError={addError}
          removeError={removeError}
          checkCageLength={checkCageLength}
          initiateImage={initiateImage}
          setInitiateImage={setInitiateImage}
          isSaving={isSaving}
              savePile={savePile}
        />
      )}

      <Modal
        show={showUnsavedWarning}
        onHide={continueEditing}
        centered
        backdrop="static"
        keyboard={false}
        dir={rightToLeft ? "rtl" : "ltr"}
        dialogClassName="unsaved-warning-modal"
      >
        <Modal.Header>
          <Modal.Title>{t("notice", { ns: "tool" })}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="unsaved-warning-modal__body">
            <div className="unsaved-warning-modal__icon">!</div>

            <div>
              <strong>{t("unsaved changes", { ns: "tool" })}</strong>
              <p>{t("unsaved item message", { ns: "tool" })}</p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unsaved-warning-modal__continue"
            onClick={continueEditing}
          >
            {t("continue editing", { ns: "tool" })}
          </Button>

          <Button
            className="unsaved-warning-modal__discard"
            onClick={discardChangesAndClose}
          >
            {t("discard changes", { ns: "tool" })}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={showSaveErrorModal}
  onHide={() => setShowSaveErrorModal(false)}
  centered
  backdrop="static"
  keyboard={false}
  dir={rightToLeft ? "rtl" : "ltr"}
  dialogClassName="unsaved-warning-modal"
>
  <Modal.Header>
    <Modal.Title>{t("save pile failed", { ns: "tool" })}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="unsaved-warning-modal__body">
      <div className="unsaved-warning-modal__icon">
        !
      </div>

      <div>
        <strong>{t("could not save item", { ns: "tool" })}</strong>

        <p>
          {saveErrorMessage ||
            t("save retry message", { ns: "tool" })}
        </p>
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      className="unsaved-warning-modal__continue"
      onClick={() => setShowSaveErrorModal(false)}
    >
      {t("understood", { ns: "tool" })}
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Pile;